module.exports = __webpack_public_path__ + "static/strafe1-18f968f19960760a0f4ccc6cb2185998.png";